// extracted by mini-css-extract-plugin
module.exports = {"arrowIcon":"categories-panel-arrow_arrowIcon__3KKMQ","arrowIconOpen":"categories-panel-arrow_arrowIconOpen__RelaA"};